import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Influencer() {
  const location = useLocation();

  useEffect(() => {
    const searchQueryParamForInfluencer = new URLSearchParams(
      location.search
    ).get("influencer");
    if (searchQueryParamForInfluencer) {
      localStorage.setItem("influencer", searchQueryParamForInfluencer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <div></div>;
}
